import { t } from "@lingui/macro";
import { useEffect, useState } from "react";

import { HStack, Text } from "@whoosh/design-system/src/components/primitive";
import { getUnlocksIn, getUnlocksInValues } from "@whoosh/utilities/src/dates";

export const RestrictionBlockFooter = ({
  unlocksAt,
}: {
  unlocksAt?: string | null;
}) => {
  const [unlocksInString, setUnlocksInString] = useState<string | null>(null);

  useEffect(() => {
    if (unlocksAt) {
      const unlocksInValue = getUnlocksIn(unlocksAt);
      setUnlocksInString(unlocksInValue);

      const interval = setInterval(() => {
        const unlocksInValue = getUnlocksIn(unlocksAt);
        setUnlocksInString(unlocksInValue);
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    } else {
      setUnlocksInString(null);
    }
  }, [unlocksAt]);

  const getUnlocksInVariant = () => {
    if (unlocksAt) {
      const { daysLeft, hoursLeft, minutesLeft, secondsLeft } =
        getUnlocksInValues(unlocksAt);
      if (!!daysLeft && !!hoursLeft) return "mainBaseMedium";
      else if (!!minutesLeft || !!secondsLeft) return "mainTitle2";
      else return "mainTitle2";
    }
  };

  return unlocksInString ? (
    <HStack alignItems="flex-end" justifyContent="space-between" mt={4}>
      <Text variant="mainBaseMedium">{t`Opens: `}</Text>
      <Text variant={getUnlocksInVariant()}>{unlocksInString || ""}</Text>
    </HStack>
  ) : null;
};
